import React from 'react'

export const MultiLineBody = ({ body }: { body: string | undefined }) => {
  const texts = body?.split('\n').map((item, index) => {
    return (
      <React.Fragment key={index}>
        {item}
        <br />
      </React.Fragment>
    )
  })

  return (
    <>
      {texts ?? ''}
    </>
  )
}
